import {useTranslate} from '@tolgee/react'
import {AlertBox} from '@/shared/components/ui/alert-box'

export function GFRMissingDataAlert({missingSex, missingWeight}: {missingSex?: boolean; missingWeight?: boolean}) {
  const {t} = useTranslate('common')

  return (
    <AlertBox
      message={missingSex ? t('gfr.missing_sex') : missingWeight ? t('gfr.missing_weight') : t('gfr.missing_bsa')}
    />
  )
}
